import React from 'react';
import { DEFAULT_IMAGE_URL, getOptimizedImageUrl } from '../lib/images';

export const ResponsiveImage = ({
  src,
  alt,
  className,
  width,
  quality,
  eager = false,
  fallbackSrc = DEFAULT_IMAGE_URL,
  onError,
  ...props
}) => {
  const resolvedWidth = width || 1200;
  const resolvedQuality = quality || 75;
  const optimizedSrc = getOptimizedImageUrl(src || fallbackSrc, {
    width: resolvedWidth,
    quality: resolvedQuality,
  });

  return (
    <img
      {...props}
      src={optimizedSrc}
      alt={alt}
      className={className}
      loading={eager ? 'eager' : 'lazy'}
      fetchPriority={eager ? 'high' : 'auto'}
      decoding="async"
      referrerPolicy="no-referrer"
      onError={(event) => {
        if (event.currentTarget.dataset.fallbackApplied === 'true') {
          onError?.(event);
          return;
        }

        event.currentTarget.dataset.fallbackApplied = 'true';
        event.currentTarget.src = getOptimizedImageUrl(fallbackSrc, {
          width: resolvedWidth,
          quality: resolvedQuality,
        });
        onError?.(event);
      }}
    />
  );
};